import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import BorrowingsPage from '@pages/borrowings/BorrowingsPage';
import BorrowingCreatePage from '@pages/borrowings/BorrowingCreatePage';
import BorrowingEditPage from '@pages/borrowings/BorrowingEditPage';
import BorrowingReturnPage from '@pages/borrowings/BorrowingReturnPage';
import BorrowingBorrowPage from '@pages/borrowings/BorrowingBorrowPage';
import BorrowingViewPage from '@pages/borrowings/BorrowingViewPage';

export const BorrowingsRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<Navigate to="/borrowings/my-borrowings" replace />} />
            <Route path="/my-borrowings" element={<BorrowingsPage />} />
            <Route path="/all-borrowings" element={<BorrowingsPage />} />
            <Route path="/calendar" element={<BorrowingsPage />} />
            <Route path="/pending-validations" element={<BorrowingsPage />} />
            <Route path="/create" element={<BorrowingCreatePage />} />
            <Route path="/:id" element={<BorrowingViewPage />} />
            <Route path="/:id/edit" element={<BorrowingEditPage />} />
            <Route path="/:id/return" element={<BorrowingReturnPage />} />
            <Route path="/:id/borrow" element={<BorrowingBorrowPage />} />
        </Routes>
    );
};

export default BorrowingsRoutes;
